<template>
    <div v-if="tienePreciosOnline" class="d-flex flex-fill justify-content-end">
        <button v-if="agotadas" class="button large-button red-content" disabled>
            {{ $t('partidos.agotadas') }}
        </button>
        <button v-else-if="ultimas_entradas" class="button large-button red-content w-auto" disabled>
            {{ $t('eventos.ultimas_entradas') }}
        </button>
        <GoToCheckoutButton
            v-else-if="comprar"
            :title="$t('partidos.comprar')"
            :route="ruta"
            :event_id="event.id"
            :sesion_id="event.sesion_id"
            :data-testid="'comprar-evento-' + event.id"
            tipo_venta="normal"
        />
    </div>
</template>

<script>
    import GoToCheckoutButton from "@/components/frontend/events/show/GoToCheckoutButton";

    export default {
        props: {
            event: {
                type: Object,
                required: true
            },
            esLfpSga: {
                type: Boolean
            }
        },
        computed: {
            ruta() { 
                return this.event.varias_sesiones ? 'front.eventos.sesiones' : 'front.eventos.show'; 
            },
            comprar() {
                if (this.esLfpSga) {
                    return this.event.libres;
                }

                return this.event.libres && this.event.entradas_disponibles?.length;
            },
            agotadas() {
                if (this.esLfpSga) {
                    return (!this.event.libres && !this.event.sesiones_activas) || this.event.entradas_agotadas_online;
                }

                return (!this.event.libres && !this.event.sesiones_activas) || this.event.entradas_agotadas_online || !this.event.entradas_disponibles?.length;
            },
            ultimas_entradas() {
                return !this.event.libres && this.event.sesiones_activas;
            },
            tienePreciosOnline() {
                if (this.esLfpSga) return true;

                const ahora = new Date();
                return this.event.entradas_disponibles?.some(e => {
                    return new Date(e.sale_start) <= ahora && ahora <= new Date(e.sale_stop);
                }) ?? false;
            }
        },
        components: {
            GoToCheckoutButton
        }
    }
</script>